export default __webpack_public_path__ + "static/media/mortyrickmissing.719c0ad6.png";